<template>
  <v-dialog v-model="dialog" width="400px">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="invoiceDetails.invoice.processed == true"
        color="blue lighten-2"
        class="text-none"
        dark
        @click="dialog = true"
      >Change Invoice Commission</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Change Commission</span>
      </v-card-title>
      <v-card-text>
        <p>This will change the commission of all trips for the invoice to a percentage of the bookings final cost. E.g. entering 30 will take a £3 commission from a £10 trip</p>
      </v-card-text>
      <!-- <v-card-text>
        <p>This will change the commission of all trips for the invoice. If a trip has had its commission changed manually, the commission will remain the same, unless the 'Force Update Commission' checkbox is selected</p>
      </v-card-text>-->
      <v-layout column px-4>
        <v-text-field
          type="number"
          v-model="commission"
          min="0"
          class="small-text-field"
          single-line
          height="28"
          text
        ></v-text-field>
        <p style="color:red;" v-if="commissionError != null">{{ commissionError }}</p>
      </v-layout>
      <v-card-actions v-if="loading == false">
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">Cancel</v-btn>
        <v-btn text @click="changeCommission()">Confirm</v-btn>
      </v-card-actions>
      <v-progress-linear v-if="loading == true" indeterminate color="yellow darken-2"></v-progress-linear>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";

import qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  name: "ChangeCommissionDialog",
  mounted: function() {},
  components: {},
  props: {
    invoiceDetails: Object
  },
  data: function() {
    return {
      loading: false,
      dialog: false,
      commissionError: null,
      reason: null,
      commission:
        this.invoiceDetails.driver == null
          ? 0
          : this.invoiceDetails.driver.fee_percentage
    };
  },
  methods: {
    changeCommission: async function() {
      console.log("Changing commission");

      this.commissionError = null;

      if (this.commission == null || this.amount < 0 || this.commission > 100) {
        this.commissionError =
          "Commission percentage must be between 0 and 100";
        return;
      }

      this.loading = true;

      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/invoice/driver/manuallySetCommissionForInvoice?invoice_id=${this.invoiceDetails.invoice.id}&commission=${this.commission}&force=true`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        this.loading = false;

        if (response.data.error == "no_error") {
          this.dialog = false;

          this.$emit(
            "commissionChanged",
            this.invoiceDetails.driver == null
              ? null
              : this.invoiceDetails.driver.id,
            this.invoiceDetails.invoice.id,
            response.data.invoice
          );
        } else {
          if (response.data.message != null) {
            this.error = response.data.message;
          } else {
            this.error = "Unknown Error";
          }
        }
      } catch (error) {
        console.log(error);
        this.commissionError = "Unknown Error";

        this.loading = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-timeline-item {
  padding-bottom: 8px !important;
}

.v-timeline {
  padding-top: 8px !important;
}
</style>

   
